import React from "react";
import jwtDecode from "jwt-decode";
import { Link, useLocation } from "react-router-dom";
import MenuAccessGate from "./MenuAccessGate";
import LegacyMenuAccessGate from "./LegacyMenuAccessGate";
import { resolveMenuRouteAction, resolveProtectedMenuPath } from "./menuRouteAccess";
import { USE_DB_SIDEBAR } from "../SidebarMenu/LayoutNavbar";

export default function MenuRouteGate({ moduleName, moduleReady = true, useDatabaseMenu = USE_DB_SIDEBAR, children }) {
  const { pathname } = useLocation();
  if (/^\/support\/admin(?:\/|$)/i.test(pathname)) {
    let isAcctree = false;
    try {
      const claims = jwtDecode(localStorage.getItem("token") || "");
      const roles = claims.role ?? claims["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
      isAcctree = (Array.isArray(roles) ? roles : [roles])
        .some(role => String(role || "").toLowerCase() === "acctree");
    } catch {
      // An invalid token does not grant access to support administration.
    }
    if (!isAcctree) return <div style={{ padding: 32 }}><h1>Qasja nuk lejohet</h1><Link to="/dashboard">Kthehu te paneli</Link></div>;
  }
  if (!moduleReady && /^\/Sales\/Addsalesindetails(?:\/|$)/i.test(pathname)) {
    return <div role="status" style={{ padding: 32 }}>Duke kontrolluar modulin…</div>;
  }
  const menuPath = resolveProtectedMenuPath(pathname, moduleName);
  const action = resolveMenuRouteAction(pathname);

  if (!menuPath) return <>{children}</>;

  if (!useDatabaseMenu) {
    return <LegacyMenuAccessGate key={`${menuPath}:${action}`} menuPath={menuPath} action={action}>{children}</LegacyMenuAccessGate>;
  }

  return (
    <MenuAccessGate key={`${menuPath}:${action}`} path={menuPath} action={action}>
      {children}
    </MenuAccessGate>
  );
}
